import React from "react";
import { useWizard } from "../../hooks/useWizard";
import { WizardProvider } from "../../providers/WizardProvider";
import { Modal, ModalContainer } from "../Modal/index";
import { Stepper } from "../Stepper";
import ShowWIzardIcon from "./ShowWizardIcon";

const FormWizard = () => {
  return (
    <WizardProvider>
      <Wizard />
    </WizardProvider>
  );
};

const Wizard = () => {
  const { showWizard } = useWizard();

  if (!showWizard) return <ShowWIzardIcon />;

  return (
    <ModalContainer>
      <Modal>
        <Stepper />
      </Modal>
    </ModalContainer>
  );
};

export default FormWizard;
